import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=f3e1f6b4&scoped=true&"
import script from "./OrderDetail.ts?vue&type=script&lang=ts&"
export * from "./OrderDetail.ts?vue&type=script&lang=ts&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=f3e1f6b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e1f6b4",
  null
  
)

export default component.exports